<template>
  <div >
   
    <!-- 表格 v-loading="loading"-->
    <el-table
      v-loading.fullscreen.lock="fullscreenLoading"
      :data="tableData"
      v-model="multipleSelection"
      :row-key="getRowKeyOfTarget"
      ref="multipleTable"
      border @selection-change="handleSelectonChange"> 
      <!-- 选择导出  @select="handleSelectChange"-->
      <el-table-column v-if="showSwitch"
        type="selection"
        :reserve-selection="true"
        width="55">
      </el-table-column>

      <!-- 序号 -->
      <el-table-column 
        label="序号"
        fixed="left"
        width="50" v-if="showTag">
        <span slot-scope="scope">
          {{ scope.$index+1 }}
        </span>
      </el-table-column>
      <el-table-column type='expand' v-if="!showTag">
        <template slot-scope="props">
          <el-form label-position="left" :inline="true" class="demo-table-expand">
            <el-row v-for="(item,index) in props.row.ssPushInDtoList" :key="index">
              <el-col :span="4">
                <el-form-item label="订单单号:">
                  <span>{{ item.thirdOrderCode }}</span>
                </el-form-item>
              </el-col>
               <el-col :span="3">
                <el-form-item label="订单状态:">
                  <span>{{ item.statusName }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="3">
                <el-form-item label="服务类型:">
                  <span>{{item.serviceType}}</span>
                </el-form-item>
              </el-col>
              <el-col :span="14">
                <el-form-item label="备注:">
                  <span>{{ item.remark }}</span>
                </el-form-item> 
               </el-col> 
            </el-row>
          </el-form>
        </template>
      </el-table-column>

      <!-- 显示内容 -->
      <template  v-for="(item, index) in configurationData">     
        <el-table-column           
          :key="index"
          :prop="item.propertys"
          :label="item.title"
          :width="item.width"
          style="color: #EA5656"
          >
          <span slot="num" slot-scope="record, index">
            {{ index+1 }}
          </span>
          <template slot-scope="scope">
            <div  v-if="item.format">
              {{ item.format(scope.row)}}
            </div>
            <!-- <div v-if="item.num">
              {{ scope }}
            </div> -->
            <div v-else-if="item.link">
              <el-link type="primary"  @click="item.link(scope.row)">{{scope.row[item.propertys]}}</el-link>
            </div>         
            <div  v-else >
                {{scope.row[item.propertys]}}
            </div>
        </template>
        </el-table-column>
      </template>
   

      <!-- 操作 -->
      <el-table-column v-if="operation.show" fixed="right" label="操作" :width="operation.width">
        <template slot-scope="scope">
          <slot name="operation" :row="scope.row"></slot>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="showSpan">
      <span>累计总收益金额:{{totalMoney}}元，可提现金额:{{withdrawalMoney}}元，累计已提现金额:{{finishWithdrawalMoney}}元，累计待结算金额:{{noSettledMoney}}元；</span>
    </div>
    <!-- 分页 -->
    <div class="fr clearfix">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.pageNum"
        :page-sizes="[5, 10, 20, 30, 40]"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next,jumper"
        :total="totalNum">
      </el-pagination>
    </div>
   
  </div>
</template>

<script>
import common from '../../public/static/common.js'
import { Loading, loading } from 'element-ui'

  export default {
    name: 'MyTable',
    data () {
      return {
        page: {
          pageNum: 1, // 当前页，默认1
          pageSize: 10 // 每页行数，默认10
        },
        totalNum: 0, // 总数
        tableData: [],
        multipleSelection: [],
        fullscreenLoading: false,
        totalMoney: 0,
        finishWithdrawalMoney: 0,
        noSettledMoney: 0,
        withdrawalMoney: 0
      }
    },
    props: {
      // 配置类数据(表头信息，宽度等)
      configurationData: {
        type: Array,
        required: true
      },
      // 操作按钮设置
      operation: {
        type: Object,
        required: true
      },
      //表单参数和URL
      getTableParam:{
        type: Object,
        required: true
      },
      showTag:{
        type: Boolean,
        default:true,
      },
      showSwitch: {
        type: Boolean,
        default: false
      },
      showSpan: {
        type: Boolean,
        default: false
      }
    },
    watch:{
      multipleSelection: function(){
        let arr = []
        for(let i in this.multipleSelection){
          if (this.multipleSelection[i].extensionPolicyId){
            arr.push(this.multipleSelection[i].extensionPolicyId)
          } else {
            arr.push(this.multipleSelection[i].id)
          }
          
        }
        this.$emit('selection',this.multipleSelection)
      }
    },
    methods:{
      query(currentPage){
        this.fullscreenLoading=true
        // Loading.service(tableData)
        // //console.log('config',this.configurationData)
        if(currentPage) this.page.pageNum=currentPage;
        // this.tableData=[];
        // this.totalNum=0;
        let param =Object.assign({},this.page,this.getTableParam.param);
        //console.log('table-param',param,'getTable',this.getTableParam)
        if(common.getCurrUserRoleList()[0].roleCode!='admin'){
          param.agentCode = common.getCurrUser().agentCode
        }
        let url = this.getTableParam.url;
        // console.log('url',url,'param',param)
        // debugger;
        this.axios.post(url, param).then((resp) => {
          // console.log('resp',resp)
          if(resp.status=='200'){
            if (resp.config.url == "/extwarapi/api/user/accountManagePage") {
            console.log('11')
              this.tableData = resp.data.result.page.data
              this.totalNum = resp.data.result.page.totalNum
              this.totalMoney = resp.data.result.totalMoney
              this.finishWithdrawalMoney = resp.data.result.finishWithdrawalMoney
              this.noSettledMoney = resp.data.result.noSettledMoney
              this.withdrawalMoney = resp.data.result.withdrawalMoney
              this.fullscreenLoading = false
            }else {
              if(resp.data.result){
                console.log('22')
                this.tableData=resp.data.result.data;   
                this.totalNum=resp.data.result.totalNum;
                this.fullscreenLoading = false
              }  
              else{
                console.log('33')
                this.fullscreenLoading=false
                this.tableData=[];
                this.totalNum=0;
              }
            }
          }else{
            this.fullscreenLoading = false
            this.$notify.error({
              title: '加载错误'
            })
          }          
        }).catch((resp) => {
          console.log('error', resp)
        })
      },
      handleSizeChange(val) {
        // this.page.pageNum=1;    
        this.page.pageSize = val;
        this.query();        
      },
      handleCurrentChange(val) {        
        this.page.pageNum = val;
        this.query();
      },
      getRowKeyOfTarget(row){
        // //console.log('row',row)
        return row.extensionPolicyId
      },
      // 获取多选参数
      handleSelectonChange(val){
        // this.multipleSelection=val
        // //console.log('选中的值',val)
        let data = this.$refs.multipleTable.selection 
        this.multipleSelection = data
        //console.log('this.$refs',data)
        // this.$emit('selection',this.multipleSelection)
      },
      // 清除选中状态
      clear(){
        //console.log('清除选中',this.multipleTable)
        // this.multipleSelection = []
        // if(this.multipleSelection){
          this.$refs.multipleTable.clearSelection()
        // }
      }
      
    },
    mounted(){
      this.query();
    }
    
 
    
  }
</script>

<style scoped  lang="scss">

</style>
